import React, { Component } from 'react';
import i18n from '../../../i18n';
import '../../../styles/components/category-pills.scss';

const current_lng = localStorage.getItem('I18N_LANGUAGE');

export class CategoryPillsOnline extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeCategory: props.activeCategory || 'all',
        };
        this.scrollRef = React.createRef();
    }

    selectCategory = (id) => {
        this.setState({ activeCategory: id });
        this.props.onCategoryChange?.(id);
    };

    render() {
        const { activeCategory } = this.state;
        const categories = (this.props.categories || []).filter(cat => cat.id !== 10);
        const showCount = this.props.showCount || false;
        const totalCount = categories.reduce((sum, c) => sum + (c.count || 0), 0);
        const showAll = categories.length > 1;

        return (
            <div className="cp-wrap">
                <div className="cp-pills-row">
                    <div className="cp-pills-scroll" ref={this.scrollRef}>
                        {showAll && (
                            <button
                                className={`cp-pill ${activeCategory === 'all' ? 'cp-pill--active' : ''}`}
                                onClick={() => this.selectCategory('all')}
                            >
                                <span className="cp-pill__label">{i18n.t('all') || 'All'}</span>
                                {showCount && <span className="cp-pill__count">{totalCount}</span>}
                            </button>
                        )}
                        {categories.map(cat => {
                            const name = current_lng === 'ar'
                                ? (cat.category_name_ar || cat.category_name)
                                : cat.category_name;
                            const isActive = String(activeCategory) === String(cat.id);

                            return (
                                <button
                                    key={cat.id}
                                    className={`cp-pill ${isActive ? 'cp-pill--active' : ''}`}
                                    onClick={() => this.selectCategory(cat.id)}
                                >
                                  
                                    <span className="cp-pill__label">{name}</span>
                                    {showCount && cat.count > 0 && (
                                        <span className="cp-pill__count">{cat.count}</span>
                                    )}
                                </button>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

export default CategoryPillsOnline;